import { Injectable } from '@angular/core'
import moment from 'moment'

const enShortRelativeTime = {
  parentLocale: 'en',
  relativeTime: {
    future: '%s',
    past: '%s ago',
    s:  'seconds',
    ss: '%ss',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M:  '1M',
    MM: '%dM',
    y:  '1Y',
    yy: '%dY'
  }
}

@Injectable({providedIn: 'root'})
export class MomentLocaleService {

  // Defines custom locales globally. Used in app.component.
  // Custom locales can be used locally on instances like moment().locale('enShortRelativeTime').fromNow()
  init(): void {
    moment.locale('enShortRelativeTime', enShortRelativeTime)

    // Needs to be last to be default
    moment.locale('en')
  }
}
